import { PurchaseDetail, PurchaseFormValues } from "../../../types/purchases/BasePurchase";

export function mapCreditNote(purchase: PurchaseDetail): PurchaseFormValues {
  const creditNote = purchase.creditNoteDetails;

  const taxableSubtotal = creditNote?.taxableSubtotal ?? 0;
  const perceivedIVA = creditNote?.perceivedIVA ?? 0;
  const totalToRefund = creditNote?.totalToRefund ?? null;

  return {
    id: purchase.id,
    documentType: purchase.documentType,
    documentNumber: purchase.documentNumber,
    purchaseDate: purchase.purchaseDate,
    supplier: purchase.supplier,
    comments: purchase.comments || '',
    cancellationReason: purchase.cancellationReason || '',
    products: creditNote?.products || [],
    paymentCondition: null,

    creditDueDate: '',
    creditDays: 0,
    totalQuantity: null,
    netAmount: null,
    freight: null,
    insurance: null,
    fauca: null,
    otherCosts: null,
    exportIva: null,
    totalCost: null,

    // ✅ Totales correctos
    taxableSubtotal,
    perceivedIVA,
    totalToRefund,

    withheldIVA: 0,
  };
}
